import reducer from './reducer'

import * as entitiesOperations from './operations'
import * as entitiesSelectors from './selectors'

export { entitiesOperations, entitiesSelectors }

export default reducer
